import{jsxs as e,jsx as t,Fragment as r}from"react/jsx-runtime";import n from"tailwind-styled-components";import i from"clsx";import l from"react-flip-numbers";import{twString as s}from"../utils.js";const a=n.div`
  relative
`,o=n.div`
  absolute
  bg-brand-accent
  inline-flex
  items-center
  justify-center
  min-w-[1.125rem]
  right-0
  rounded-full
  text-white
  [font-size:_0.625rem]
  h-[1.1rem]
  leading-none
  p-1
  top-0
  -translate-y-1/3
  translate-x-1/3
  z-20
`,m=s`
  min-w-0
  h-2
  w-2
  p-0
  translate-x-0
  translate-y-0
`,c=({children:n,className:s,count:c=0,max:p=99,showCounter:d=!0,...f})=>{const h=i(s,{[m]:!d});return e(a,{...f,children:[c>0&&t(o,{className:h,role:"superscript",children:t("span",{className:i({"-translate-y-[0.5px] inline-flex items-center":c<=p}),children:d&&(c>p?e(r,{children:[p,t("span",{className:"-translate-y-px inline-block",children:"+"})]}):t(l,{color:"#fff",height:11,numbers:`${c}`,play:!0,width:6}))})}),n]})};export{c as default};
